import React, { Component, ErrorInfo } from "react";

export default class ErrorBoundary extends Component<{ children: React.ReactNode; className?: string }> {
    state: { error?: Error; errorInfo?: ErrorInfo } = {};

    componentDidCatch = (error: Error, errorInfo: ErrorInfo) => {
        this.setState({ error, errorInfo });
    };

    render() {
        if (this.state.errorInfo) {
            const isChunkLoadError =
                this.state.error?.name === "ChunkLoadError" ||
                this.state.error?.message.startsWith("Loading chunk ") ||
                this.state.error?.message.startsWith("Loading CSS chunk ");

            return (
                <div className={this.props.className ? this.props.className : ""}>
                    <div className="text-center py-5">
                        <h2 className={isChunkLoadError ? "icon-uEA18-update" : "icon-uEA04-cancel"} />
                        {isChunkLoadError ? (
                            <>
                                <h5>Не удалось загрузить часть страницы</h5>
                                <p className="text-muted mb-0">
                                    Такое бывает после обновления приложения или при перебоях с интернетом.
                                    <br />
                                    Обновите страницу и попробуйте ещё раз.
                                </p>
                                <button
                                    type="button"
                                    className="btn btn-brand mt-3"
                                    onClick={() => window.location.reload()}
                                >
                                    Обновить страницу
                                </button>
                            </>
                        ) : (
                            <>
                                <h5>
                                    Что-то пошло не так. <br />
                                    Попробуйте&nbsp;
                                    <span className="link" onClick={() => window.location.reload()}>
                                        обновить
                                    </span>
                                    &nbsp;страницу.
                                </h5>
                                <details style={{ whiteSpace: "pre-wrap" }}>
                                    <summary>Детали</summary>
                                    {this.state.error?.toString()}
                                    <br />
                                    {this.state.errorInfo.componentStack}
                                </details>
                            </>
                        )}
                    </div>
                </div>
            );
        } else {
            return this.props.children;
        }
    }
}
